<template>
  <section class="section-3 alpha-section wrapper">
    <div class="hd">
      <h2 class="title">
        TTPS Alpha班
      </h2>
    </div>

    <div class="content">
      <div
        v-for="(item, i) in list"
        :key="i"
        class="content-item"
        :class="{ active: i === current}"
        @mouseenter="onCurrentChange(i)"
      >
        <div class="content-item__thumb">
          {{ item.title }}
        </div>

        <!-- <span
          class="btn-next"
          @click="onCurrentChange(i + 1)"
        /> -->
      </div>
    </div>

    <btn-contact name="B页-TTPS Alpha班-预约咨询" />
  </section>
</template>

<script>
import BtnContact from './BtnContact.vue';

export default {
  components: {
    BtnContact,
  },
  data() {
    return {
      current: 0,
      list: [
        { title: 'TTPS教练团小班教学' },
        { title: '日内九大交易策略' },
        { title: '实战派职业养成' },
        { title: '无风险$500实盘PK' },
      ],
    };
  },
  methods: {
    onCurrentChange(i) {
      this.current = i > this.list.length - 1 ? 0 : i < 0 ? 0 : i;
    },
  },
};
</script>

<style lang="scss" scoped>
.section-3 {
  padding-top: percentage(32px / $deviceWidth);
  padding-bottom: percentage(84px / $deviceWidth);
  background: url("~assets/Point.png") center top/100% auto no-repeat;
  @include hdpi() {
    background-image: url("~assets/Point@2x.png");
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: percentage(293px / $deviceWidth);
    padding-top: percentage(394px / $deviceWidth);
    margin-top: percentage(-210px / $deviceWidth);
    background: url("~assets/Clip.png") center/contain no-repeat;
    @include hdpi() {
      background-image: url("~assets/Clip@2x.png");
    }
  }

  &.active {
    .content {
      &-item {
        animation: adf .2s 1s ease-out both;
      }
    }
  }

  .title {
    width: percentage(607px / $deviceWidth);
    padding-top: percentage(142px / $deviceWidth);
  }

  .content {
    $contentWidth: 340px * 3 + 420px;
    margin: percentage(120px / $deviceWidth) auto percentage(74px / $deviceWidth);
    width: percentage($contentWidth / $deviceWidth);
    @include clearfix();

    &-item {
      position: relative;
      display: inline-block;
      float: left;
      width: percentage(340px / $contentWidth);
      padding-top: percentage(543px / $contentWidth);
      transition: all .3s;
      will-change: width;
      cursor: pointer;

      &.active {
        width: percentage(420px / $contentWidth);

        .btn-next {
          opacity: 1;
          visibility: visible;
        }
      }

      @for $i from 1 through 4 {
        &:nth-of-type(#{$i}) {
          background: url("~assets/c#{$i}-bg.png") left center/auto 100% no-repeat;
          @include hdpi() {
            background-image: url("~assets/c#{$i}-bg@2x.png");
          }

          .content-item__thumb {
            background: url("~assets/c#{$i}.png") left center/100% auto no-repeat;
            @include hdpi() {
              background-image: url("~assets/c#{$i}@2x.png");
            }
          }
        }
      }

      .content-item__thumb {
        position: absolute;
        top: percentage(36px / 543px);
        left: 50%;
        transform: translate(-50%, 0);
        width: percentage(366px / 420px);
        height: percentage(452px / 543px);
      }

      .btn-next {
        visibility: hidden;
        opacity: 0;
        position: absolute;
        top: percentage(104px / 543px);
        right: percentage(-54px / 420px);
        z-index: 5;
        width: percentage(94px / 420px);
        padding-top: percentage(95px / 420px);
        cursor: pointer;
        transition: transform .3s, opacity cubic-bezier(0.075, 0.82, 0.165, 1);
        will-change: transform, opacity;
        background: url("~assets/btn-next.png") center/100% auto no-repeat;
        @include hdpi() {
          background-image: url("~assets/btn-next@2x.png");
        }

        &:hover {
          transform: scale(1.02);
        }
      }
    }
  }

  @include mediaWidth(1024px) {
    .content {
      width: 85%;
    }
  }

  @include mediaWidth(#{$mbWidth}) {
    padding-top: percentage(70px / $mbWidth);
    padding-bottom: percentage(46px / $mbWidth);
    background-position: center percentage(51px / $mbWidth);

    &::before {
      content: none;
    }
    .title {
      width: percentage(375px / $mbWidth);
      padding-top: percentage(87px / $mbWidth);
    }
    .content {
      width: 100%;
      padding: 0 percentage(45px / $mbWidth);
      margin: percentage(72px / $mbWidth) auto percentage(50px / $mbWidth);
      white-space: nowrap;
      overflow: auto;

      &-item, .content-item.active {
        float: none;
        width: percentage(297px / $mbWidth);
        padding-top: percentage(383px / $mbWidth);
        margin-right: percentage(40px / $mbWidth);

        @for $i from 1 through 4 {
          &:nth-of-type(#{$i}) {
            background: url("~assets/alpha-#{$i}-m.png") left center/auto 100% no-repeat;
            @include hdpi() {
              background-image: url("~assets/alpha-#{$i}-m@2x.png");
            }

            .content-item__thumb {
              background: none;
            }
          }
        }

        .btn-next {
          display: none;
        }
      }
    }
  }
}
</style>
